// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LFUs","buttons":"Footer_buttons__3DRxz"};